/*
 * @Author: hujingyang
 * @Date: 2021-02-03 15:05:01
 * @Description:
 * @LastEditors: Do not edit
 * @LastEditTime: 2021-02-03 15:31:21
 * @FilePath: \DouYinStore\src\pages\ordersCare\components\OrderPaymentMIssion\components\SectionTitle\index.tsx
 * @IDE: Created by VScode.
 */

import React from 'react';
import styles from './index.module.scss';

/**
 * 段落标题格式化组件
 * @param title  主标题(必选)
 * @param preface 序号(必选)
 */
const SectionTitle = ({ title, preface }: { title: string; preface: string }): JSX.Element => {
  return (
    <section>
      <div className={styles.mainBox}>
        <div className={styles.preface}>{preface}</div>
        <div className={styles.title}>{title}</div>
      </div>
    </section>
  );
};
export default SectionTitle;
